<swal
  #failedSwal
  [title]="title()"
  [text]="message()"
  icon="error"
  [showCancelButton]="showCancelButton()"
  [showConfirmButton]="showConfirmButton()"
  [focusCancel]="true"
  [cancelButtonText]="cancelButtonText()"
  [confirmButtonText]="confirmButtonText()"
  (dismiss)="dismiss.emit()"
  (confirm)="confirm.emit()"
>
  <div *swalPortal="swalTargets.content" class="space-y-2">
    <ng-content></ng-content>
    @if (errorMessage()) {
      <div class="px-4 italic">{{ errorMessage() }}</div>
      <app-pan-button icon="content_copy" (click)="copyDetails.emit()">Copy error</app-pan-button>
    }
  </div>
</swal>
